/* eslint-disable jira/filename-case */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, jsx } from '@atlaskit/css';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import AkSpinner from '@atlaskit/spinner/spinner';

export default function Spinner({ testId }: { testId?: string }): JSX.Element {
	return (
		<UFOLoadHold name="legacy-spinner">
			<div css={styles.container}>
				<div css={styles.wrapper}>
					<AkSpinner size="large" testId={testId} />
				</div>
			</div>
		</UFOLoadHold>
	);
}

const styles = cssMap({
	container: {
		display: 'flex',
		justifyContent: 'center',
		alignContent: 'center',
		height: '100%',
	},
	wrapper: {
		alignSelf: 'center',
	},
});
